module.exports = __webpack_public_path__ + "static/media/DecCreditcardAvantCloud.6343939f.tsx";